import { render, staticRenderFns } from "./port-number-validate.vue?vue&type=template&id=5c1430c6"
import script from "./port-number-validate.vue?vue&type=script&lang=js"
export * from "./port-number-validate.vue?vue&type=script&lang=js"
import style0 from "./port-number-validate.vue?vue&type=style&index=0&id=5c1430c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports